<template>
    <div class="px-6 py-10">
        <!-- Page Title -->
        <h1 class="text-2xl font-medium text-gray-800 mb-8 p-6">Contact Us</h1>

        <div class="flex flex-col lg:flex-row gap-10">
            <!-- list -->
            <div class="w-full lg:w-1/3">
                <!-- Header -->
                <h2 class="text-gray-600 text-lg font-medium mb-6 tracking-wide">CUSTOMER SUPPORT</h2>

                <!-- Support Card -->
                <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-8">

                    <!-- Telephone Section -->
                    <div class="flex items-start space-x-4">
                        <div class="flex-shrink-0 mt-1">
                            <component :is="Phone" class="w-5 h-5 text-gray-400"/>
                        </div>
                        <div class="flex-1">
                            <h3 class="text-gray-800 font-medium mb-2">Telephone:</h3>
                            <!--                        <div class="flex items-center gap-x-2">-->
                            <div class="text-primary font-medium whitespace-nowrap inline-block">+351 21 381 62 00</div>
                            <p class="inline-block text-gray-600">from Portugal and abroad (national call cost)</p>
                            <!--                        </div>-->
                        </div>
                    </div>

                    <!-- Support Section -->
                    <div class="flex items-start space-x-4">
                        <div class="flex-shrink-0 mt-1">
                            <component :is="Headset" class="w-5 h-5 text-gray-400"/>
                        </div>
                        <div class="flex-1">
                            <h3 class="text-gray-800 font-medium mb-2">Support:</h3>
                            <p class="text-gray-600">Support on business days from 9:00 am to 6:00 pm</p>
                        </div>
                    </div>

                    <!-- Email Section -->
                    <div class="flex items-start space-x-4">
                        <div class="flex-shrink-0 mt-1">
                            <component :is="Mail" class="w-5 h-5 text-gray-400"/>
                        </div>
                        <div class="flex-1">
                            <h3 class="text-gray-800 font-medium mb-2">E-mail:</h3>
                            <a href="mailto:customer.service@bisonaccount.com" class="text-primary font-medium hover:text-orange-600 transition-colors">
                                customer.service@bisonaccount.com
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-full lg:w-2/3">
                <h2 class="text-gray-600 text-lg font-medium mb-6 tracking-wide">LEAVE US A MESSAGE</h2>

                <form>
                    <div class="mb-4">
                        <input type="text" name="subject"
                               v-model="formData.Subject"
                               class="border border-gray-400 px-2 py-3 w-full rounded-lg focus:outline-none focus:border-blue-400" placeholder="Subject *" required>
                    </div>

                    <div class="mb-4">
                        <input type="text" name="name"
                               v-model="formData.Name"
                               class="border border-gray-400 px-2 py-3 w-full rounded-lg focus:outline-none focus:border-blue-400" placeholder="Name *" required>
                    </div>

                    <div class="mb-4">
                        <input type="text" name="email"
                               v-model="formData.Email"
                               class="border border-gray-400 px-2 py-3 w-full rounded-lg focus:outline-none focus:border-blue-400" placeholder="Email *" required>
                    </div>

                    <div class="mb-4">
                        <textarea id="message" name="message"
                          v-model="formData.Message"
                          class="border border-gray-400 px-2 py-3 w-full rounded-lg focus:outline-none focus:border-blue-400" placeholder="Message *" rows="5"></textarea>
                    </div>
                    <div class="flex justify-left gap-x-2">

                        <button type="button" @click="clearFormData" class="w-1/4 flex items-center justify-center gap-1 bg-white text-primary px-4 py-3 rounded-lg shadow">
                            <span>Clear</span>
                        </button>

                        <button type="submit" class="w-1/4 flex items-center justify-center gap-1 bg-primary text-white px-4 py-3 rounded-lg shadow">
                            <span>SEND</span>
                        </button>

                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Phone, Headset, Mail } from 'lucide-vue-next'
import {ref} from "vue";

const formData = ref({
    Subject: '',
    Name: '',
    Email: '',
    Message: '',
});

function clearFormData() {
    formData.value.Subject = '';
    formData.value.Name = '';
    formData.value.Email = '';
    formData.value.Message = '';
}

</script>

<style scoped>

</style>